import {
  UNSTABLE_ToastQueue as ToastQueue,
  UNSTABLE_ToastRegion as ToastRegion,
} from "react-aria-components";
import type { QueuedToast, ToastOptions } from "react-aria-components";
import { flushSync } from "react-dom";

import { DEFAULT_TOAST_TIMEOUT } from "@/lib/constants/delay";
import { cn } from "@/lib/helpers/cn";
import { Toast2 } from "@/ui2/molecules/Toast";
import type { ToastContent as ToastContentType } from "@/ui2/molecules/Toast";

export type Toast = QueuedToast<ToastContentType>;
export type ToastParams = [ToastContentType, ToastOptions?];

export const toastProviderQueue = new ToastQueue<ToastContentType>({
  // Wrap state updates in a CSS view transition.
  wrapUpdate(fn) {
    if ("startViewTransition" in document) {
      document.startViewTransition(() => {
        flushSync(fn);
      });
    } else {
      fn();
    }
  },
});

export function showToast([content, options]: ToastParams) {
  return toastProviderQueue.add(content, {
    timeout: DEFAULT_TOAST_TIMEOUT,
    ...options,
  });
}

export function ToastProvider({ children }: { children: React.ReactNode }) {
  return (
    <>
      <ToastRegion
        className={cn(
          "react-aria-ToastRegion",
          "tw:fixed tw:right-5 tw:top-[calc(var(--header-height)+20px)] tw:z-10",
        )}
        queue={toastProviderQueue}
      >
        {({ toast }) => <Toast2 style={{ viewTransitionName: toast.key }} toast={toast} />}
      </ToastRegion>

      {children}
    </>
  );
}
